var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagrams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "diagrams",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.719 18.625",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1,430.611H38.61a0.74,0.74,0,0,1-.749-0.73v-9.306a0.74,0.74,0,0,1,.749-0.73H43.1a0.74,0.74,0,0,1,.749.73v9.306A0.74,0.74,0,0,1,43.1,430.611Zm-3.744-1.46h2.995v-7.845H39.358v7.845Zm-4.118,1.46H30.748a0.74,0.74,0,0,1-.749-0.73V412.729a0.74,0.74,0,0,1,.749-0.73H35.24a0.74,0.74,0,0,1,.749.73v17.152A0.74,0.74,0,0,1,35.24,430.611Zm-3.743-1.46h2.995V413.459H31.5v15.692Zm19.467,1.46H46.472a0.739,0.739,0,0,1-.748-0.73V415.466a0.739,0.739,0,0,1,.748-0.73h4.493a0.74,0.74,0,0,1,.749.73v14.415A0.74,0.74,0,0,1,50.964,430.611Zm-3.744-1.46h2.995V416.2H47.22v12.954Z",
    transform: "translate(-30 -412)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagrams);
export default __webpack_public_path__ + "static/media/diagrams.d1dcd5919b1b1df428796a18a29bba4f.svg";
export { ForwardRef as ReactComponent };